import { Component, inject, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService, UserService } from 'src/app/core';

@Component({
  selector: 'app-edit-user-score',
  templateUrl: './edit-user-score.component.html',
  styleUrls: ['./edit-user-score.component.scss'],
})
export class EditUserScoreComponent {
  public form: FormGroup;
  readonly dialogRef = inject(MatDialogRef<EditUserScoreComponent>);
  userId: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) dialogData: any,
    private fb: FormBuilder,
    private adminService: AdminService,
    private snackBar: MatSnackBar
  ) {
    this.form = fb.group({
      reason: [null, Validators.required],
      operation: ['received', Validators.required],
      score: ['0'],
    });
    if (dialogData) this.userId = dialogData.userId;
  }
  submitForm() {
    const request = this.form.value;
    if (request.score) request.score = +request.score;
    const added =
      this.form.controls['operation'].value === 'paid' ? 'کسر' : 'اضافه';
    this.adminService
      .editUserScore(this.userId, request)
      .subscribe((res: any) => {
        if (res) {
          this.snackBar.open(`امتیاز با موفقیت ${added} شد.`, '', {
            duration: 1000,
          });
          setTimeout(() => {
            this.dialogRef.close();
          }, 100);
        }
      });
  }
}
